import {HttpMethod as Http, Token, UrlMethod} from '@ox/typings';

import {OX_KEYS} from '../keys';
import {makeAPI} from './api';
import {apiUrlMap} from './api-url-map';

/*
  Intentionally not typing this as `ApiUrls` because the compiler
  thinks we cannot index into it due to an unknown amount of string
  indexes. Because this is a an object literal we do not have this
  problem at runtime.
*/
export const apiUrls = {
  profile: makeAPI<Token>(
    apiUrlMap.profile.person,
    [Http.GET],
    OX_KEYS.OWNER_PROFILE_KEY
  ),
  getOwnerProfile: makeAPI<Token>(
    apiUrlMap.profile.getOwnerProfile,
    [Http.GET],
    OX_KEYS.INIT_LOGIN_SUCCESS_DATA
  ),
  getVehicles: makeAPI<Token>(
    apiUrlMap.garage.getVehicles,
    [Http.GET],
    OX_KEYS.GARAGE_KEY
  ),
  activeVehicleMileage: makeAPI<UrlMethod>(
    apiUrlMap.vehicle.active.mileage,
    [Http.GET],
    OX_KEYS.VEHICLE.ACTIVE.MILEAGE_UPDATED_KEY
  ),
  locateDealerByCityState: makeAPI<UrlMethod>(
    apiUrlMap.dealer.locateByCityState,
    [Http.GET],
    OX_KEYS.LOCATE_DEALER_BY_CITY_STATE
  ),
  locateDealerByCity: makeAPI<UrlMethod>(
    apiUrlMap.dealer.locateByCity,
    [Http.GET],
    OX_KEYS.LOCATE_DEALER_BY_CITY
  ),
  locateDealerByZip: makeAPI<UrlMethod>(
    apiUrlMap.dealer.locateByZip,
    [Http.GET],
    OX_KEYS.LOCATE_DEALER_BY_ZIP
  ),
  locateDealerByName: makeAPI<UrlMethod>(
    apiUrlMap.dealer.locateByDealerName,
    [Http.GET],
    OX_KEYS.LOCATE_DEALER_BY_NAME
  ),
  locateDealerByLocation: makeAPI<UrlMethod>(
    apiUrlMap.dealer.locateDealerLatLong,
    [Http.GET],
    OX_KEYS.LOCATE_DEALER_BY_LATLONG
  ),
  recallsGfas: makeAPI<UrlMethod>(
    apiUrlMap.recallsGfas.get,
    [Http.GET],
    OX_KEYS.RECALLS_GFAS_KEY
  ),
  getPreferredDealer: makeAPI<UrlMethod>(
    apiUrlMap.dealer.getPreferredDealer,
    [Http.GET],
    OX_KEYS.DEALER.PREFERRED_KEY
  ),
  setPreferredDealer: makeAPI<UrlMethod>(
    apiUrlMap.dealer.setPreferredDealer,
    [Http.PUT],
    OX_KEYS.DEALER.PREFERRED_KEY
  ),
  recallCampaignVin: makeAPI<Token>(
    apiUrlMap.recallCampaignVin.decryptVin,
    [Http.POST],
    OX_KEYS.DECRYPT_VIN
  ),
  takataSignUp: makeAPI<Token>(
    apiUrlMap.takataSignUp.saveTakataRecallData,
    [Http.POST],
    OX_KEYS.TAKATA_SIGN_UP
  ),
  takataSMS: makeAPI<Token>(
    apiUrlMap.takataSignUp.signupForSMS,
    [Http.POST],
    OX_KEYS.TAKATA_SMS_SIGN_UP
  ),
  getReviewPlanInfo: makeAPI<Token>(
    apiUrlMap.review.getReviewPlanInfo,
    [Http.GET],
    OX_KEYS.GET_REVIEW_INFO
  ),
  quote: makeAPI<Token>(
    apiUrlMap.shop.quote,
    [Http.GET],
    OX_KEYS.CHECKOUT_QUOTE
  ),
  copy: makeAPI<UrlMethod>(
    apiUrlMap.shop.copy,
    [Http.GET],
    OX_KEYS.COPYDATA
  ),
  recurringCharges: makeAPI<Token>(
    apiUrlMap.shop.recurringCharges,
    [Http.GET],
    OX_KEYS.RECURRING_CHARGES
  ),
  getAllFeatureFlags: makeAPI<Token>(
    apiUrlMap.featureFlags.getAll,
    [Http.GET],
    OX_KEYS.LAUNCH_DARKLY
  ),
  authRecommendedProducts: makeAPI<Token>(
    apiUrlMap.shop.authRecommendedProducts,
    [Http.GET],
    OX_KEYS.AUTH_RECOMMENDED_PRODUCTS
  ),
  unauthRecommendedProducts: makeAPI<Token>(
    apiUrlMap.shop.unauthRecommendedProducts,
    [Http.GET],
    OX_KEYS.UNAUTH_RECOMMENDED_PRODUCTS
  ),
  ymalAssets: makeAPI<UrlMethod>(
    apiUrlMap.shop.ymalAssets,
    [Http.GET],
    OX_KEYS.YMAL_ASSETS
  ),
  authComparePlan: makeAPI<Token>(
    apiUrlMap.shop.authComparePlan,
    [Http.GET],
    OX_KEYS.AUTH_COMPARE_PLAN
  ),
  unauthComparePlan: makeAPI<Token>(
    apiUrlMap.shop.unauthComparePlan,
    [Http.GET],
    OX_KEYS.UNAUTH_COMPARE_PLAN
  ),
  unAuthPricing: makeAPI<Token>(
    apiUrlMap.shop.unAuthPricing,
    [Http.GET],
    OX_KEYS.UNAUTH_PRICING
  ),
  authPricing: makeAPI<Token>(
    apiUrlMap.shop.authPricing,
    [Http.GET],
    OX_KEYS.AUTH_PRICING
  ),
  unAuthOffers: makeAPI<Token>(
    apiUrlMap.shop.unAuthOffers,
    [Http.GET],
    OX_KEYS.UNAUTH_OFFERS
  ),
  authOffers: makeAPI<Token>(
    apiUrlMap.shop.authOffers,
    [Http.GET],
    OX_KEYS.AUTH_OFFERS
  ),
  orderApiEndPoint: makeAPI<Token>(
    apiUrlMap.placeOrder.orderApiEndPoint,
    [Http.GET],
    OX_KEYS.ORDER_API
  ),
  statusApiEndPoint: makeAPI<Token>(
    apiUrlMap.placeOrder.statusApiEndPoint,
    [Http.GET],
    OX_KEYS.STATUS_API
  )
};
